
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import AuthProvider from './context/AuthProvider';
import Dashboard from './pages/Dashboard/Dashboard';
import DashboardHome from './pages/Dashboard/DashboardHome/DashboardHome';
import AddEvent from './pages/Dashboard/Events/AddEvent/AddEvent';
import Events from './pages/Dashboard/Events/Events';
import EventsList from './pages/Dashboard/Events/EventsList/EventsList';
import UpdateEvent from './pages/Dashboard/Events/UpdateEvent/UpdateEvent';
import Media from './pages/Dashboard/Media/Media';
import Home from './pages/Home/Home';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/dashboard" element={<Dashboard />}>
            <Route path="" element={<DashboardHome />}></Route>
            <Route path="media" element={<Media />}></Route>
            <Route path="events" element={<Events />}>
              <Route path="" element={<EventsList />}></Route>
              <Route path="add-new" element={<AddEvent />}></Route>
              <Route path="update/:id" element={<UpdateEvent />}></Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
